(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amb-main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initTabs(section) {
      const tabsComponent = section.querySelector('tabs-component');

      if (!tabsComponent) {
        const tabPanels = section.querySelectorAll('[ref="tab-panel"]');
        if (tabPanels.length === 0) {
          section.remove();
        }
        return;
      }

      const tabPanels = tabsComponent.querySelectorAll('[ref="tab-panel"]');

      if (tabPanels.length === 0) {
        section.remove();
        return;
      }

      function getActivePanel() {
        const panels = tabsComponent.querySelectorAll('[ref="tab-panel"]');
        for (const panel of panels) {
          if (!panel.hidden) {
            return panel;
          }
        }
        return null;
      }

      function getActiveSlideshow() {
        const activePanel = getActivePanel();
        if (!activePanel) return null;
        return activePanel.querySelector('slideshow-component');
      }

      function updateSlideshowVisibility(panel) {
        if (!panel) return;

        const allSlideshows = panel.querySelectorAll('slideshow-component');
        allSlideshows.forEach(slideshow => {
          if (slideshow.refs && slideshow.refs.scroller) {
            const current = slideshow.current || 0;
            slideshow.select(current, undefined, { animate: false });
          }
        });
      }

      function updateNavButtons() {
        const activeSlideshow = getActiveSlideshow();
        const tabActions = tabsComponent.querySelectorAll('.tab-actions [ref="tab-action"]');

        tabActions.forEach(action => {
          if (!action.classList.contains('carousel-nav-button')) return;

          const isActive = action.classList.contains('active');
          if (!isActive) {
            action.style.display = 'none';
            return;
          }

          action.style.display = '';

          if (!activeSlideshow) {
            action.disabled = true;
            return;
          }

          const slideshowRefs = activeSlideshow.refs || {};
          const isPrev = action.classList.contains('carousel-nav-button--prev');
          const isNext = action.classList.contains('carousel-nav-button--next');

          if (isPrev && slideshowRefs.previous) {
            const originalPrev = slideshowRefs.previous;
            action.disabled = originalPrev.disabled;
            action.classList.toggle('hidden', originalPrev.classList.contains('hidden'));
          } else if (isNext && slideshowRefs.next) {
            const originalNext = slideshowRefs.next;
            action.disabled = originalNext.disabled;
            action.classList.toggle('hidden', originalNext.classList.contains('hidden'));
          }
        });
      }

      function navigateCarousel(direction) {
        const activeSlideshow = getActiveSlideshow();
        if (!activeSlideshow) return;

        const slideshowRefs = activeSlideshow.refs || {};

        if (direction === 'previous' && slideshowRefs.previous) {
          slideshowRefs.previous.click();
        } else if (direction === 'next' && slideshowRefs.next) {
          slideshowRefs.next.click();
        }
      }

      tabsComponent.addEventListener('tab:change', () => {
        setTimeout(() => {
          const activePanel = getActivePanel();
          if (activePanel) {
            updateSlideshowVisibility(activePanel);
          }
          updateNavButtons();
        }, 100);
      });

      const allSlideshows = tabsComponent.querySelectorAll('slideshow-component');
      allSlideshows.forEach(slideshow => {
        slideshow.addEventListener('slideshow:select', () => {
          const activeSlideshow = getActiveSlideshow();
          if (slideshow === activeSlideshow) {
            setTimeout(updateNavButtons, 50);
          }
        });
      });

      if (!tabsComponent.hasAttribute('initialized')) {
        setTimeout(() => {
          tabsComponent.setAttribute('initialized', '');
        }, 0);
      }

      const tabActions = tabsComponent.querySelectorAll('.tab-actions [ref="tab-action"]');
      tabActions.forEach(action => {
        if (action.classList.contains('carousel-nav-button--prev')) {
          action.addEventListener('click', (e) => {
            e.preventDefault();
            navigateCarousel('previous');
            setTimeout(updateNavButtons, 100);
          });
        } else if (action.classList.contains('carousel-nav-button--next')) {
          action.addEventListener('click', (e) => {
            e.preventDefault();
            navigateCarousel('next');
            setTimeout(updateNavButtons, 100);
          });
        }
      });

      const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
            const panel = mutation.target;
            if (!panel.hidden) {
              setTimeout(() => {
                updateSlideshowVisibility(panel);
              }, 50);
            }
          }
        });
        updateNavButtons();
      });

      const tabPanelsForObserver = tabsComponent.querySelectorAll('[ref="tab-panel"]');
      tabPanelsForObserver.forEach(panel => {
        observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
      });

      setTimeout(() => {
        const activePanel = getActivePanel();
        if (activePanel) {
          updateSlideshowVisibility(activePanel);
        }
        updateNavButtons();
      }, 50);
    }

    function initAllTabs() {
      const sections = document.querySelectorAll('.section-content-tabs');
      sections.forEach(section => {
        setTimeout(() => {
          initTabs(section);
        }, 100);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(initAllTabs, 100);
      });
    } else {
      setTimeout(initAllTabs, 100);
    }

    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        const section = event.target.querySelector('.section-content-tabs');
        if (section) {
          setTimeout(() => initTabs(section), 100);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
